import { IAction, IAppState } from '../context/Context'
import { Views } from '../../enums'

export namespace View {
  export const reducer = (
    prevState: IAppState,
    { view }: IAction
  ): IAppState => {
    const updatedState = { ...prevState }
    switch (view) {
      case Views.manageSettings: {
        updatedState.view = Views.manageSettings
        break
      }
      case Views.partnerSettings: {
        updatedState.view = Views.partnerSettings
        break
      }
      default: {
        updatedState.view = Views.default
        break
      }
    }
    return updatedState
  }
}
